<aside class="p2 p-l-1 p-r-1 col-w b-radius-4"
       [style.background-color]="color">
    <ng-content>
    </ng-content>
</aside>